import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type CPTableDataEmptyLoc = 'CPTableDataEmptyContent';

export const cpTableDataEmptyLocs: LocDefs<CPTableDataEmptyLoc> = {
	CPTableDataEmptyContent: {
		defaultValue: 'No data to show',
		description: 'Text displayed when the data table or grid has no data to display',
		displayPath: 'Data View|No Data Found',
		displayType: 'Content',
		shared: true,
		portal: 'CP',
		feature: HubFeature.CandidateAccess,
	},
};

export const LOC_KEYS = MapLocKeys<CPTableDataEmptyLoc>(cpTableDataEmptyLocs);
export type CPTableDataEmptyLocType = LocMap<CPTableDataEmptyLoc>;
